import * as Highcharts from 'highcharts';
import highchartsExporting from 'highcharts/modules/exporting';
import highchartsExportData from 'highcharts/modules/export-data';
import noDataToDisplay from 'highcharts/modules/no-data-to-display';
import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import dayjs from 'dayjs';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import Chart from '../common/Chart';
import ChartProvider from '../../contexts/ChartContext';
dayjs.extend(dayOfYear);

highchartsExporting(Highcharts);
highchartsExportData(Highcharts);
noDataToDisplay(Highcharts);

type Props = {
  rain_dates: any;
  reference: any;
  solutions: any[];
  ymin: number;
  ymax: number;
};

const SoilingRatioChart = ({ rain_dates, reference, solutions, ymin, ymax }: Props) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (reference.hasOwnProperty('times') && solutions.length > 0) {
      prepareData();
    }
  }, [reference, solutions]);

  const prepareData = () => {
    let dataObject: any = {
      times: [],
      values: {},
      units: {},
      title: 'Soiling Ratio',
      xTitle: 'Soiling Ratio',
    };

    dataObject['times'] = reference?.times;
    dataObject['values'] = {
      soiling_ratio: [...reference?.values?.soiling_ratio],
    };
    dataObject['units'] = reference?.units;

    (solutions || []).forEach((item: any) => {
      // Extend solution data to handle cleaning schedules that wrap to next year
      let extendedSolutionData = [...(item?.data?.daily?.values?.soiling_ratio || [])];

      // If solution data is shorter than reference, extend it by repeating the pattern
      while (extendedSolutionData.length < reference?.times.length) {
        extendedSolutionData.push(extendedSolutionData[extendedSolutionData.length - 1] || 1.0);
      }

      dataObject['values'][item.name + '_soiling_ratio'] = extendedSolutionData;
      dataObject['units'][item.name + '_soiling_ratio'] = item?.data?.daily?.units?.soiling_ratio;

      if (solutions.length === 1) {
        dataObject['values']['cleaning'] = item?.cleaning_graph;
        dataObject['cleaning_dates'] = item?.schedule;
      }
    });

    dataObject['rain_dates'] = rain_dates;
    setData(dataObject);
  };

  return (
    <>
      <Box sx={{ justifyContent: 'center', pl: 1, pr: 1 }}>
        {data ? (
          <>
            <ChartProvider>
              <Box>
                <Chart data={data} ymin={ymin} ymax={ymax} />
              </Box>
            </ChartProvider>
          </>
        ) : null}
      </Box>
    </>
  );
};

export default SoilingRatioChart;
